import React from 'react'
import smallimg from '../../Images/networking 1.png'
import smallimg1 from '../../Images/interaction 1.png'
import smallimg2 from '../../Images/Group 427319853.png'
import smallimg3 from '../../Images/Group 427319852.png'
const BusinessCardRapid = () => {
    return (
        <>
            <div className='business_card_rapid_manner'>
                <h4>in a rapid, contemporary, and sustainable manner</h4>

                <div className='business_card_rapid_content_wrapper'>
                    <div className='business_card'>
                        <div className='business_Card_logo_img'>
                            <img src={smallimg} />
                        </div>
                        <div className='business_card_logo_content'>
                            <h5>Better Networking</h5>
                            <h6>

                                Make your company and yourself seem more inventive and professional</h6>

                        </div>
                    </div>

                    <div className='business_card'>
                        <div className='business_Card_logo_img'>
                            <img src={smallimg1} />
                        </div>


                        <div className='business_card_logo_content'>
                            <h5>Enhanced Interactions</h5>
                            <h6>

                                Point visitors to your website, social media accounts, or further digital resources.</h6>

                        </div>
                    </div>

                    <div className='business_card'>

                    <div className='business_Card_logo_img'>
                            <img src={smallimg2} />
                        </div>


                        <div className='business_card_logo_content'>
                            <h5>Budget-Friendly</h5>
                            <h6>

                            Your business card can be updated and used again and again without incurring extra production expenses with lifetime validity.</h6>

                        </div>
                    </div>
                    <div className='business_card'>
                    <div className='business_Card_logo_img'>
                            <img src={smallimg3} />
                        </div>


                        <div className='business_card_logo_content'>
                            <h5>Eco-friendly</h5>
                            <h6>

                            Cut down on the waste produced by old paper business cards and help create an organization that is more environmentally friendly.</h6>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BusinessCardRapid